import { VodafoneTariffTable } from './components/VodafoneTariffTable';

export const overduePaymentsVodafoneTariffQueryId = 'admin/vodafoneTariff/overduePayments';

export const OverduePaymentsTab = () => {
  return (
    <VodafoneTariffTable
      queryId={overduePaymentsVodafoneTariffQueryId}
      modifier="withPendingPayments"
      tabName="overdue-payments"
    />
  );
};
